'use strict';
var cp = require('child_process');
// create processes
var path = require('path');
var workerModule1 = path.join(__dirname,'digits-band.js');
var worker = null;
var latestStackEntry = null;

var createWorker = function(workerName) {
  worker = cp.fork(workerName, { env : { ALGOINCHILDPROCESS : 1 } });
  worker.on('message', function(obj) {
    //console.log('workermessage')
    if(latestStackEntry){
      clearTimeout(latestStackEntry.timerId)
      latestStackEntry.callback(obj.err, obj.result);
      latestStackEntry = null;
    } else {
      console.log("digitreader 2 callback not found from stack");
    }
  })
  worker.on('exit', function(){
    console.log('worker '+ workerName + ' exit');
    createWorker(workerName)
    if(latestStackEntry){
      clearTimeout(latestStackEntry.timerId)
      latestStackEntry.callback("workerName exited and restarted");
      latestStackEntry = null;
    }
  })
}

createWorker(workerModule1);

module.exports.analyzeImage = function (pixels, config, callback, debugImage) {

  latestStackEntry = {callback:callback};

  worker.send({config:config, id:new Date().getTime()});

  latestStackEntry.timerId = setTimeout(function() {
    if(latestStackEntry){
      latestStackEntry.callback("timeout");
      latestStackEntry = null;
    } else {
      console.log("digitreader 2 callback not found from stack");
    }

  }, 18000) // 15 seconds is maximum time for algorihms
}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/digitreader2-master.js
// module id = 828
// module chunks = 0